import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import counterpart from 'counterpart';
import updateDimensions from 'Utils/updateDimensions';
import Listener from 'Utils/listener';
import { initLanguage } from 'Utils/languages';
import whichTransitionEvent from 'Utils/transitionEndUtil';
import { setAccountNumberId } from 'Actions/accountNumberAction';
import { successNotificationBanner, closeNotificationBanner } from 'Actions/notificationAction';

import {
  getAuthRole,
  isUserAuthenticatedSelector,
} from 'Selectors';

/* import Enzyme from 'enzyme';
import Adapter from 'enzyme-adapter-react-16'; */

import ResponseBanner from 'Components/cards/ResponseBanner';
import ExpandedOverviewPane from 'Components/ExpandedOverviewPane/ExpandedOverviewPane';
import Navigation from '../Navigation';
import Main from '../Main';
import Drawer from '../Drawer';
import SiteHeader from '../SiteHeader';
import { getAuthenticatedUser } from '../../api/authApi';
import * as authActions from '../../actions/authActions';
import timelineDetailView from 'Components/timelineDetailView/timelineDetailView';
import translate from 'counterpart';
import { getExpandedOverviewData } from 'Containers/CaseLanding/configStructure';
import { initCommonTranslate } from 'Utils/languages';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { setDrawerOpenFlag } from 'Actions/drawerAction';
import SessionMonitor from 'Components/session/SessionMonitor';
import ImagePortal from 'Containers/ImagePortal';

//Enzyme.configure({ adapter: new Adapter() });

export class LayoutAuthenticated extends Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.resetScrollPos = this.resetScrollPos.bind(this);

    const authRole = getAuthRole(this.props.auth);

    this.state = {
      isDrawerOpen: false,
      isSecondaryDrawerOpen: false,
      drawerIsExtended: false,
      authRole,
      hasOverlay: false,
      navigationToggled: false,
      transitionEnded: true,
      ready: false,
      scrollPos: 0,
      navCollapsed: 'expanded',
      isNavExpandedOnHover: false,
      displayStructure: getExpandedOverviewData(),
    };

    this.attachBindings();
    this.attachListeners();

  }

  componentDidMount() {

    translate.setLocale("en-US");
    // if (this.props.isAuthenticated) {
    //   //Need to define accessToken
    //   const accessToken = this.props.auth.accessToken;

    //   getAuthenticatedUser(accessToken)
    //     .then((userResponse) => {
    //       if (userResponse.data) {

    //         this.setupAuthenticatedUser(accessToken, userResponse.data);
    //       } else {
    //         const getAuthenticatedUserError = new Error('Error retrieving user.');
    //         throw getAuthenticatedUserError;
    //       }
    //     })
    //     .catch((userResponse) => {
    //       this.props.history.push('/logout');
    //     });
    // }

    document.addEventListener('mousedown', this.handleClickOutside);
    this.updateDimensions();

    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keypress', this.onKeyPress);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.location.pathname !== newProps.location.pathname) {
      this.setState({
        toggleNav: !this.state.toggleNav,
      });
    }
  }

  componentDidUpdate() {
    if (this.state.width > 1024 && this.state.navigationToggled) {
      this.toggleNavigation();
      this.transitionEventDone();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
  }

  onKeyPress(event) {
    const banner = { ...this.props.banner };
    const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
      case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
        banner.closeNotification();
        break;
    }
  }

  setBodyOverflow() {
    if (this.state.navigationToggled || this.state.isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  setupTranslationDefaults = () => {
    counterpart.setFallbackLocale(['en-US', 'en-GB', 'zh-Hans', 'zh-Hant', 'fr-CA', 'en-CA']);
    counterpart.setMissingEntryGenerator(() => {
      return '';
    });
  }
  setupAuthenticatedUser(accessToken, newUser) {
    let user;

    if (accessToken === undefined && newUser === undefined && this.props.auth.session !== null) {
      user = this.props.auth.user;
    } else {
      user = Object.assign({}, newUser);
    }

    const userInfoArray = [];

    Promise.all(userInfoArray)
      .then((userInfoArrayResponses) => {
        this.props.authActions.loginSuccess(user);
      })
      .catch((error) => {
        console.log(error);
        redirectToLogout();
      });
  }

  toggleOverlay() {
    this.setState({
      hasOverlay: !this.state.hasOverlay,
    });
  }

  handleNavExpandedOnHover(isExpanded) {
    this.setState({ isNavExpandedOnHover: isExpanded });
  }

  attachBindings() {
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleTableRows = this.handleTableRows.bind(this);
    this.setBodyOverflow = this.setBodyOverflow.bind(this);
    this.useExtendedDrawer = this.useExtendedDrawer.bind(this);
    this.toggleSecondaryDrawer = this.toggleSecondaryDrawer.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.acceptTerms = this.acceptTerms.bind(this);
    this.setupAuthenticatedUser = this.setupAuthenticatedUser.bind(this);
    this.toggleNavigation = this.toggleNavigation.bind(this);
    this.transitionEndAnimation = this.transitionEndAnimation.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.transitionEventDone = this.transitionEventDone.bind(this);
    this.toggleOverlay = this.toggleOverlay.bind(this);
    this.renderResponseBanner = this.renderResponseBanner.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleNavExpandedOnHover = this.handleNavExpandedOnHover.bind(this);
  }

  attachListeners() {
    Listener.on('FILTERED_ROWS', this.handleTableRows);
    Listener.on('DRAWER_OPEN', this.setBodyOverflow);
    Listener.on('TERMS_ACCEPTED', this.acceptTerms);
    Listener.on('ROUTE_CHANGE', this.toggleNavigation);
  }


  updateDimensions() {
    const dimensions = updateDimensions();
    this.setState({ width: dimensions.width, height: dimensions.height }, () => {
      if (this.state.width < 1024 && !this.state.transitionEnded) {
        this.transitionEventDone();
      }
    });
  }

  // eslint-disable-next-line react/sort-comp
  renderResponseBanner() {
    const banner = { ...this.props.banner };
    return (
      <div>
         <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={banner.title}
          description={banner.description}
          type={banner.type}
          onClose={banner.closeNotification}
          cancel
          secondaryButtonText={banner.secondaryButtonText}
          primaryButtonText={banner.primaryButtonText}
          cancelButtonText={banner.cancelButtonText}
          isSecondaryButton
          isSecondaryButtonActive={banner.isSecondaryButtonActive}
          secondaryButtonAction={banner.secondaryButtonAction}
          primaryButtonAction={banner.primaryButtonAction}
          primaryButtonActionValue={banner.primaryButtonActionValue}
          cancelOnly={banner.cancelOnly}
          textField={banner.textField}
          timeLeft={banner.timeLeft}
          isDetokenize={banner.isDetokenize}
          descriptionHtml={banner.descriptionHtml}
        />
        </ImagePortal>
      </div>
    );
  }

  transitionEventDone() {
    this.setState({ transitionEnded: true });
  }

  acceptTerms() {
    this.props.authActions.acceptTerms();
  }


  handleClickOutside(event) {
    if (event.target.classList.contains('overlay') && this.state.navigationToggled) {
      this.setState({ navigationToggled: false });
    } else if (event.target.classList.contains('overlay') && !this.state.navigationToggled) {
      Listener.trigger('FILTERS_DRAWER_CLOSED');
    }
  }

  handleTableRows(rows) {
    this.filteredRows = rows;
  }

  toggleDrawer() {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
    }, () => {
      Listener.trigger('DRAWER_OPEN');
    });
  }

  toggleSecondaryDrawer() {
    this.setState({ isSecondaryDrawerOpen: !this.state.isSecondaryDrawerOpen });
  }

  toggleNavigation() {
    this.transitionEndAnimation();
  }

  useExtendedDrawer() {
    this.setState({ drawerIsExtended: !this.state.drawerIsExtended });
  }

  transitionEndAnimation() {
    this.setState({ transitionEnded: false }, () => {
      const transitionEvent = whichTransitionEvent();
      document.addEventListener(transitionEvent, (animationEvent) => {
        if (animationEvent.srcElement.className === 'vertical-nav-label'
          || animationEvent.srcElement.className.indexOf('navigation') > -1) {
          this.transitionEventDone();
        }
      });
    });
  }

  updateCurrency(selectedCurrency) {
    this.props.authActions.updateCurrency(selectedCurrency);
  }


  resetScrollPos() {
    this.state.scrollPos = 0;
  }

  handleScroll() {
    if ((document.body.getBoundingClientRect()).top < (this.state.scrollPos - 10) && (document.body.getBoundingClientRect()).top < -85) {
      document.body.classList.remove('instant-header');
      document.body.classList.add('hide-header');
      this.state.scrollPos = (document.body.getBoundingClientRect()).top;
    } else if ((document.body.getBoundingClientRect()).top > (this.state.scrollPos + 10)) {
      document.body.classList.remove('hide-header');
      this.state.scrollPos = (document.body.getBoundingClientRect()).top;
    }
  }

  toggleNavState = () => {

    if (this.state.navCollapsed === 'expanded') {
      this.setState({
        navCollapsed: 'collapsed'
      }, function () {
        localStorage.setItem('navstate', this.state.navCollapsed);
      });
    } else {
      this.setState({
        navCollapsed: 'expanded'
      }, function () {
        localStorage.setItem('navstate', this.state.navCollapsed);
      });
    }

  }

  render() {
    const overlayClass = classNames({
      'with-overlay': this.state.isDrawerOpen || this.state.navigationToggled || this.state.hasOverlay,
    });

    const wrapperClass = classNames('page-wrapper');


    return (
      !this.props.location.pathname.includes('casedetails') && !this.props.location.pathname.includes('timelinedetails') ? <div className={this.state.isNavExpandedOnHover ? wrapperClass : this.state.navCollapsed === "collapsed" ? wrapperClass : `collapsed ${wrapperClass}`}>
        <SiteHeader
          toggleNavigation={this.toggleNavigation}
          transitionEndAnimation={this.transitionEndAnimation}
          navigationToggled={this.state.navigationToggled}
          toggleOverlay={this.toggleOverlay}
        />
        {<Navigation
          toggleNavState={this.toggleNavState}
          overlayClass={overlayClass}
          transitionEndAnimation={this.transitionEndAnimation}
          transitionEnded={this.state.transitionEnded}
          language={initLanguage(this.props.preferences.language)}
          navigationToggled={this.state.navigationToggled}
          width={this.state.width}
          navCollapsed={this.state.navCollapsed}
          handleNavExpandedOnHover={this.handleNavExpandedOnHover}
          isNavExpandedOnHover={this.state.isNavExpandedOnHover}
        />}
        {/* @TODO change this authRole to auth for all routed components in Main.js */}
        <Main
          toggleNav={this.state.toggleNav}
          termsAccepted
          authRole={this.state.authRole}
          overlayClass={overlayClass}
          parsedPermissions={this.props.parsedPermissions}
          updateCurrency={this.updateCurrency}
          resetScrollPos={this.resetScrollPos}
          navCollapsed={this.state.navCollapsed}
          user={this.props.auth.user}
          setDrawerOpenFlag={this.props.setDrawerOpenFlag}
          preferences={{ dateFormat: 'MM/dd/yyyy', timeFormat: this.props.auth.user.timeFormat }}
        />
        <div className={this.state.isDrawerOpen ? 'overlay' : 'nope'}></div>
        <Drawer
          level="primary"
          useExtendedDrawer={this.useExtendedDrawer}
          drawerIsExtended={this.state.drawerIsExtended}
          isDrawerOpen={this.state.isDrawerOpen}
          isSecondaryDrawerOpen={this.state.isSecondaryDrawerOpen}
          toggleDrawer={this.toggleDrawer}
          parentFilteredRows={this.filteredRows}
          authRole={this.state.authRole}
          auth={this.props.auth}
          toggleOverlay={this.toggleOverlay}
          toggleNavigation={this.toggleNavigation}
          transitionEndAnimation={this.transitionEndAnimation}
          navigationToggled={this.state.navigationToggled}
        />
        <SessionMonitor
          auth={this.props.auth}
          authActions={this.props.authActions}
        // warningResponseTimeoutSeconds={15}
        // sessionInactivityTimeoutSeconds={60}
        />
        <Drawer
          level="secondary"
          isSecondaryDrawerOpen={this.state.isSecondaryDrawerOpen}
          toggleSecondaryDrawer={this.toggleSecondaryDrawer}
          user={this.props.auth.user}
          auth={this.props.auth}
        />
        {this.props.notification.show && this.renderResponseBanner()}

      </div> : (!this.props.location.pathname.includes('timelinedetails') ?
        <React.Fragment><Route path="/casedetails/:caseNumber(\d+)"
          render={(props) => <ExpandedOverviewPane {...props} languageAbbr={this.props.auth.user.languageAbbr} displayStructure={this.state.displayStructure} />}
        /></React.Fragment>
        : <React.Fragment><Route path="/timelinedetails/:caseStageId(\d+)" component={timelineDetailView} /><span style={{ display: "none" }}>{window.document.title = this.props.location.search && this.props.location.search.slice(1).split("&")[1].split("=")[1]}</span></React.Fragment>)
    );
  }
}

LayoutAuthenticated.propTypes = {
  auth: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  parsedPermissions: PropTypes.object.isRequired,
  preferences: PropTypes.object.isRequired,
  language: PropTypes.string,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isDrawerActive: PropTypes.bool,
};

LayoutAuthenticated.defaultProps = {
  language: 'en-US',
};

const mapStateToProps = (state) => ({
  auth: state.auth || {},
  isAuthenticated: isUserAuthenticatedSelector(state),
  parsedPermissions: {},
  preferences: {},
  banner: state.notification.banner[0],
  notification: state.notification,
  isDrawerActive: state.drawer.isDrawerActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    setNotification: (banner) => dispatch(successNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    setAccountNumberId: (locked) => dispatch(setAccountNumberId(locked)),
    setDrawerOpenFlag: (isDrawerActive) => {
      dispatch(setDrawerOpenFlag(isDrawerActive));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutAuthenticated));
